import {Injectable} from '@angular/core';
import {KaitoriyaConfig} from '../config/kaitoriya.config';

declare var Stimulsoft: any;

/**
 * Stimulsoft 帳票フォントをページ内 1 回だけ登録する (ira-groupnet issue #151 と同対応)。
 *
 * 従来は帳票を使う各画面が msgothic001-003.ttf (各 8.4MB、計 25MB) を同期 XHR で
 * 画面遷移のたびに登録し直していた。帳票テンプレートが参照する 5 名義すべてを
 * msgothic001.ttf 1 ファイルの別名として非同期に登録し、セッション中はキャッシュする。
 */
@Injectable({providedIn: 'root'})
export class StimulsoftFontService {
    /** 唯一のフォント実体。下の全名義はこのファイルの別名 */
    static readonly FONT_FILE = '/assets/stimulsoft/fonts/msgothic001.ttf';
    static readonly FONT_NAMES = ['MS Gothic', 'MS UI Gothic', 'MS PGothic', 'MS Mincho', 'MS PMincho'];
    static readonly LOCALIZATION_FILE = '/assets/stimulsoft/localization/ja.xml';

    private loading: Promise<void> | null = null;

    /** localization + フォント登録の完了で resolve。何度呼んでも 1 回だけ実行される */
    ensureLoaded(): Promise<void> {
        if (!this.loading) {
            this.loading = this.load().catch((e) => {
                this.loading = null; // 失敗はキャッシュせず次回呼び出しでリトライ
                throw e;
            });
        }
        return this.loading;
    }

    private async load(): Promise<void> {
        const prefix = KaitoriyaConfig.PREFIX;
        Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile(prefix + StimulsoftFontService.LOCALIZATION_FILE);
        const url = prefix + StimulsoftFontService.FONT_FILE;
        const collection = Stimulsoft.Base.StiFontCollection;
        // 逐次登録: 初回リクエストがブラウザキャッシュに載り、残りの別名登録はキャッシュから返る
        for (const name of StimulsoftFontService.FONT_NAMES) {
            if (typeof collection.addOpentypeFontFileAsync === 'function') {
                await new Promise<void>((resolve) => collection.addOpentypeFontFileAsync(() => resolve(), url, name));
            } else {
                collection.addOpentypeFontFile(url, name);
            }
        }
    }
}
